import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import Icon, { IconmoonFont } from 'vibo-ui/Icon';

import { useEvent } from 'components/context/EventContext';

import useStyles from '../Location/style';

const QuestionsInfo: FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  const { event } = useEvent();

  return !!event ? (
    <div className={classes.location}>
      <Icon icon={IconmoonFont['questionCircleOutlined-16']} />
      <span className="name">
        {t('questions')} <b>{event.questionsCount}</b>
      </span>
    </div>
  ) : null;
};

export default QuestionsInfo;
